import React from "react";
import { Modal } from "../../../../core/components/templates/Modal";
import { Typography } from "../../../../core/components/molecules/Typography";
import { Button } from "../../../../core/components/atoms/Button";

interface IConfirmationModalRevision {
  text: string;
  onClose: () => void;
  onConfirm: () => void;
  isOpen: boolean;
  buttonOkText: string;
  buttonCancelText?: string;
}

const ConfirmationModalRevision: React.FC<IConfirmationModalRevision> = ({ 
  text,
  onClose,
  onConfirm,
  isOpen,
  buttonCancelText,
  buttonOkText,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => onClose()}
      position="center"
      className="p-0 xs:w-full lg:w-2/5"
    >
      <div className="flex flex-col gap-xl">
        <Typography>
          {text}
        </Typography>
        <div className="flex flex-row items-center justify-end gap-sm">
          <Button variant="text"onClick={() => onClose()}>
            <Typography>
              {buttonCancelText ? buttonCancelText : 'Cancelar'}
            </Typography>
          </Button>
          <Button variant="text" onClick={() => onConfirm()}>
            {buttonOkText}
          </Button>
        </div>        
      </div>
    </Modal>
  )
}

export default ConfirmationModalRevision;